import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.65",
      d: "M20.129 12.578c-.65-3.433-.975-5.15-2.208-6.164S14.925 5.4 11.401 5.4H10.6c-3.525 0-5.288 0-6.521 1.014S2.52 9.145 1.87 12.578c-.913 4.828-1.37 7.242-.038 8.832C3.164 23 5.643 23 10.6 23h.8c4.957 0 7.436 0 8.767-1.59.773-.923.944-2.122.772-3.91M7.67 5.4V4.3C7.67 2.477 9.162 1 11 1c1.84 0 3.33 1.477 3.33 3.3v1.1"
    }, null, -1)
  ]))]))
}
export default { render: render }